import { DEFAULT_STATION_DISTANCE } from '../../interfaces/filters';
import { IThunkActionCreator } from '../../types/store';
import { changePopupSelectedStations, changePopupStationDistance } from './actions';

export const onFiltersChanged =
  (stationDistance?: number | null, station?: number[] | null): IThunkActionCreator =>
  dispatch => {
    dispatch(changePopupStationDistance(stationDistance || DEFAULT_STATION_DISTANCE));
    dispatch(changePopupSelectedStations(station || []));
  };
